export enum OFFER_STATUSES {
  PREPARE = 1,
  ACTIVE = 2,
  ARCHIVE = 3,
  SUSPENDED = 4,
  ARCHIVE_PROLONGABLE = 5,
}
